<template>
  <transition name="fade">
    <div
      v-if="options.show"
      class="layer-popup-alert survey-progress-type survey-completed"
      style="z-index: 1000; position: fixed;"
    >
      <p class="txt">
        <template v-for="(msg, index) in splitMessages">
          {{ msg }} <br :key="index">
        </template>
      </p>
      <p
        class="img-banner"
        style="cursor: pointer"
      ><img
        :src="options.bannerPath"
        @click.stop="clickBanner"
      ></p>

      <div class="flex-c">
        <button
          class="btn-ok"
          @click="submit(true)"
        >
          확인
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { SNT } from '@/core/global/global-enums'

export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  computed: {
    splitMessages() {
      return this.options.message.split('\n')
    },
  },

  methods: {
    clickBanner() {
      if (this.options && this.options.submitCallback) {
        this.options.submitCallback(true)
      }
      if (this.options && this.options.bannerContentId) {
        if (this.options.contentType === 2) {
          this.$router.push({
            name: 'app-medical-trend-main',
            query: {
              id: this.options.bannerContentId,
              entryService: SNT.A.Service_컨텐츠__메디컬트렌드,
              entryPosition: SNT.B.Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_삽입배너,
              entryState: SNT.C.State_Action__클릭_컨텐츠
              // 기존통계 : 182
            }
          })
        } else if (this.options.contentType === 7) {
          this.$router.push({
            name: 'app-event-main',
            query: {
              id: this.options.bannerContentId,
              entryService: SNT.A.Service_컨텐츠__이벤트,
              entryPosition: SNT.B.Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_삽입배너,
              entryState: SNT.C.State_Action__클릭_컨텐츠
              // 기존통계 : 192
            }
          })
        }
      }
    },

    submit(isOk) {
      if (this.options && this.options.submitCallback) {
        this.options.submitCallback(isOk)
      }
      this.options.show = false
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
